import * as Yup from 'yup';
import { useLocation, useNavigate } from 'react-router-dom';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { Stack, Alert } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// routes
import { axiosPost, apiRouter } from '../../../services';
import { PATH_AUTH, PATH_DASHBOARD, PATH_USER_DASHBOARD } from '../../../routes/paths';
// hooks
import useIsMountedRef from '../../../hooks/useIsMountedRef';
// components
import { FormProvider, RHFTextField } from '../../../components/hook-form';
import useToaster from '../../../hooks/useToaster';
import { USER_ROLES, toastTypes } from '../../../constants/keywords';
import useAuth from '../../../hooks/useAuth';
// ----------------------------------------------------------------------

export default function LoginForm() {
  const isMountedRef = useIsMountedRef();
  const { toaster } = useToaster();
  const navigate = useNavigate();

  const location = useLocation();

  const { login } = useAuth();

  const isAdmin = location.pathname?.includes('admin');
  console.log('isAdmin :>> ', isAdmin);

  const LoginSchema = Yup.object().shape({
    loginId: Yup.string().required('Login ID is required'),
    password: Yup.string().required('Password is required'),
  });

  const defaultValues = {
    loginId: '',
    password: '',
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    reset,
    setError,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    const body = {
      loginId: data.loginId,
      password: data.password,
      role: isAdmin ? 'admin' : 'user',
    };

    try {
      const res = await login({ ...data, role: isAdmin ? 'admin' : 'user' });
      console.log('res :>> ', res);

      const { success, msg } = res;

      if (success) {
        toaster(msg, toastTypes.SUCCESS);

        if (res?.data?.role === USER_ROLES.ADMIN) {
          navigate(PATH_DASHBOARD.root);
        } else {
          navigate(PATH_USER_DASHBOARD.root);
        }
      } else {
        return toaster(msg || 'Invalid login credentials', toastTypes.ERROR);
      }
    } catch (error) {
      reset();
      if (isMountedRef.current) {
        setError('afterSubmit', { ...error, message: error.message });
      }
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>}

        <RHFTextField
          name="loginId"
          label="Login ID"
          InputProps={{
            sx: {
              color: 'white',
            },
          }}
        />
        <RHFTextField
          name="password"
          label="Password"
          type="password"
          InputProps={{
            sx: {
              color: 'white',
            },
          }}
        />
        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={isSubmitting}
        >
          Login
        </LoadingButton>
      </Stack>
    </FormProvider>
  );
}
